// Generated by `yarn tokens:import --aos-ds` from the Figma "Actions" icon section.
// Do not edit.
//
// Colour is not here on purpose: every path renders `currentColor`, so an icon
// takes its ink from `tone` like the rest of the package. The size is the one
// Figma draws at — the section holds 24px glyphs and 52px pictograms, and
// picking one for the other is not a decision this package makes.

import type { FigmaGlyph } from './glyph'

export const Plus: FigmaGlyph = {
    name: 'Plus',
    nodeId: '46:1386',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
export const Timestamp: FigmaGlyph = {
    name: 'Timestamp',
    nodeId: '16650:49837',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M12 22C9.44444 22 7.21759 21.1528 5.31944 19.4583C3.4213 17.7639 2.33333 15.6481 2.05556 13.1111H4.33333C4.59259 15.037 5.44907 16.6296 6.90278 17.8889C8.35648 19.1481 10.0556 19.7778 12 19.7778C14.1667 19.7778 16.0046 19.0231 17.5139 17.5139C19.0231 16.0046 19.7778 14.1667 19.7778 12C19.7778 9.83333 19.0231 7.99537 17.5139 6.48611C16.0046 4.97685 14.1667 4.22222 12 4.22222C10.7222 4.22222 9.52778 4.51852 8.41667 5.11111C7.30556 5.7037 6.37037 6.51852 5.61111 7.55556H8.66667V9.77778H2V3.11111H4.22222V5.72222C5.16667 4.53704 6.31944 3.62037 7.68056 2.97222C9.04167 2.32407 10.4815 2 12 2C13.3889 2 14.6898 2.26389 15.9028 2.79167C17.1157 3.31944 18.1713 4.03241 19.0694 4.93056C19.9676 5.8287 20.6806 6.88426 21.2083 8.09722C21.7361 9.31019 22 10.6111 22 12C22 13.3889 21.7361 14.6898 21.2083 15.9028C20.6806 17.1157 19.9676 18.1713 19.0694 19.0694C18.1713 19.9676 17.1157 20.6806 15.9028 21.2083C14.6898 21.7361 13.3889 22 12 22ZM15.1111 16.6667L10.8889 12.4444V6.44444H13.1111V11.5556L16.6667 15.1111L15.1111 16.6667Z',
        },
    ],
}
export const TimestampOutdated: FigmaGlyph = {
    name: 'TimestampOutdated',
    nodeId: '16650:49839',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M20.4091 16.1162L18.9444 14.6515C19.2138 14.1633 19.42 13.633 19.5631 13.0606C19.7062 12.4882 19.7778 11.899 19.7778 11.2929C19.7778 9.32323 19.0918 7.65236 17.7197 6.2803C16.3476 4.90825 14.6768 4.22222 12.7071 4.22222C12.1178 4.22222 11.5412 4.29377 10.9773 4.43687C10.4133 4.57997 9.87879 4.79461 9.37374 5.08081L7.88384 3.59091C8.60774 3.1532 9.37795 2.81229 10.1944 2.56818C11.0109 2.32407 11.8485 2.20202 12.7071 2.20202C13.9697 2.20202 15.1524 2.44192 16.2551 2.92172C17.3577 3.40152 18.3173 4.04966 19.1338 4.86616C19.9503 5.68266 20.5985 6.64226 21.0783 7.74495C21.5581 8.84764 21.798 10.0303 21.798 11.2929C21.798 12.1852 21.6759 13.0354 21.4318 13.8434C21.1877 14.6515 20.8468 15.4091 20.4091 16.1162ZM13.7172 9.42424L11.697 7.40404V6.24242H13.7172V9.42424ZM20.5859 22L17.5556 18.9697C16.8485 19.4074 16.0909 19.7525 15.2828 20.0051C14.4747 20.2576 13.6162 20.3838 12.7071 20.3838C10.3838 20.3838 8.35943 19.6136 6.63384 18.0732C4.90825 16.5328 3.91919 14.6094 3.66667 12.303H5.73737C5.97306 14.0539 6.75168 15.5017 8.07323 16.6465C9.39478 17.7912 10.9394 18.3636 12.7071 18.3636C13.33 18.3636 13.9234 18.2921 14.4874 18.149C15.0513 18.0059 15.5859 17.7912 16.0909 17.5051L7.85859 9.27273H3.61616V5.0303L2 3.41414L3.41414 2L22 20.5859L20.5859 22Z',
        },
    ],
}
